const BASENAME = process.env.REACT_APP_API_BASEPATH;

export const REQUEST_EMAIL_CODE = `${BASENAME}requestEmailCode`;
export const VALIDATE_EMAIL_CODE = `${BASENAME}validateEmailCode`;
export const CHANGE_PASSWORD = `${BASENAME}changePasswordByEmailCode`;
